import { GET_MITARBEITER_PERSONAL_IDS } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useMitarbeiterPersonalIds/graphql/queries';
import {
  Mitarbeiter_GetMitarbeiterPersonalIdsQuery,
  Mitarbeiter_GetMitarbeiterPersonalIdsQueryVariables,
} from '@/gql/graphql';
import * as Sentry from '@sentry/react';
import { useSuspenseQuery } from '@apollo/client/react';

export function useMitarbeiterPersonalIds(standortId: string): {
  personalIds: {
    vorname: string;
    nachname: string;
    personalnummer: string;
    e2nId: string | null;
  }[];
} {
  const { data, error } = useSuspenseQuery<
    Mitarbeiter_GetMitarbeiterPersonalIdsQuery,
    Mitarbeiter_GetMitarbeiterPersonalIdsQueryVariables
  >(GET_MITARBEITER_PERSONAL_IDS, {
    variables: {
      standortId,
    },
  });

  if (error) {
    Sentry.captureException(error);
    return { personalIds: [] };
  }

  return {
    personalIds: data.mitarbeiter_mitarbeiterByStandortIds.map((m) => {
      return {
        vorname: m.vorname,
        nachname: m.nachname,
        personalnummer: m.personalnummer,
        e2nId: m.e2nId ?? null,
      };
    }),
  };
}
